import { AlertNotification } from '@bo-components/alerts/AlertNotification';
import type { FormattedChannel } from '@library/types/alerts';
import { Spinner } from '@library/components/Spinner';
import { useAlertNotifications } from '@bo-hooks/alerts/useAlertNotifications';

export interface AlertNotificationsProps {
  setSelectedChannel: (channel: FormattedChannel) => void;
  setSpecificAlertId: (alertId: string) => void;
}

export const AlertNotifications = ({
  setSelectedChannel,
  setSpecificAlertId
}: AlertNotificationsProps) => {
  const { alertNotificationData, isFetching } = useAlertNotifications();

  return (
    <div className="bg-soFresh-110 text-soClean-110 flex size-full max-h-screen flex-col overflow-scroll p-6">
      {isFetching && <Spinner />}
      {alertNotificationData &&
        alertNotificationData.length > 0 &&
        !isFetching && (
          <div>
            {!isFetching &&
              alertNotificationData.map((notification) => (
                <AlertNotification
                  key={`notification ${notification.id}`}
                  notification={notification}
                  setSelectedChannel={setSelectedChannel}
                  setSpecificAlertId={setSpecificAlertId}
                />
              ))}
          </div>
        )}
      {!isFetching &&
        (!alertNotificationData || alertNotificationData.length <= 0) && (
          <p>No notifications found.</p>
        )}
    </div>
  );
};
